import { useEffect, useState } from 'react';
import { cn } from '@/lib/cn';
import { fetchHealth, type HealthState } from './api';

const STATUS: Record<HealthState, { text: string; dot: string } | null> = {
  ok: { text: 'All systems operational', dot: 'bg-success' },
  down: { text: 'Server unreachable', dot: 'bg-danger' },
  unknown: null,
};

/**
 * Dashboard footer — docs/design/dashboard region 11: copyright with the
 * hospital and branch, the build version (vite.config.ts injects it from
 * package.json), and server status from polling /health once a minute.
 */
export function DashboardFooter({ hospital, branch }: { hospital: string; branch?: string | null }) {
  const [health, setHealth] = useState<HealthState>('unknown');
  useEffect(() => {
    let alive = true;
    const check = () => fetchHealth().then(h => { if (alive) setHealth(h); });
    check();
    const id = setInterval(check, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);
  const status = STATUS[health];
  return (
    <footer className="flex flex-wrap items-center justify-between gap-2 px-0.5 pb-1 pt-3 text-[10.5px] text-ink-muted">
      <span>© {new Date().getFullYear()} {hospital}{branch ? `, ${branch}` : ''}</span>
      <span className="flex items-center gap-4">
        <span>HIS v{__APP_VERSION__}</span>
        {status && <span className="flex items-center gap-1.5"><span className={cn('h-[7px] w-[7px] rounded-full', status.dot)} />{status.text}</span>}
      </span>
    </footer>
  );
}
